module.exports = __webpack_public_path__ + "static/media/pdf.8833169f.svg";